import React, { useEffect } from 'react';
import styled from 'styled-components';

import TrustPassport from './TrustPassport';
import ReviewList from './ReviewList';
import { refreshMyTrust } from '../../Services/trustReviews';
import { useI18n } from '../../i18n/I18nProvider';

const ReputationSection = ({ profile = {}, userId, role }) => {
  const { t } = useI18n();

  useEffect(() => {
    if (!userId) return;
    refreshMyTrust().catch(() => undefined);
  }, [userId]);

  return (
    <Wrap>
      <Header>
        <div>
          <h2>{t('trust.reputationTitle')}</h2>
          <p>{t('trust.reputationSubtitle')}</p>
        </div>
      </Header>
      <TrustPassport profile={{ ...profile, user_id: userId || profile.user_id }} role={role || profile.user_type} />
      <ReviewList revieweeId={userId || profile.user_id} limit={3} compact title={t('trust.latestReviews')} />
    </Wrap>
  );
};

const Wrap = styled.section`display:grid;gap:1rem;`;
const Header = styled.header`h2{margin:0;font-size:1.02rem;}p{margin:.3rem 0 0;color:var(--color-textMuted);font-size:.76rem;line-height:1.5;}`;

export default ReputationSection;
